<template>
  <div>
    <p>
      This page should close in a few seconds.
    </p>
  </div>
</template>

<script>
import { getHashParams } from '@/core/Utils'

export default {
  name: 'Login',
  props: ['checkLogin'],
  mounted () {
    var params = getHashParams()
    if (window.opener && window.opener.spotifyLogin) {
      window.opener && window.opener.spotifyLogin(params)
      window.close()
    } else {
      this.checkLogin(params, () => {
        window.location.href = '/radio'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    text-align: center;
    width: 80%;
    display: block;
    padding: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue